import moment from "moment";
class attributs {
  constructor(
    empId,
    nameEmp,
    legajo,
    entry,
    exit,
    conceptId,
    nameConcept,
    ccId,
    nameCc,
    inProcId,
    inLine,
    outProcId,
    outLine,
    obs,
    licTot
  ) {
    this.empId = empId;
    this.nameEmp = nameEmp;
    this.legajo = legajo;
    this.entryOrigin = entry;
    this.entry = moment(entry).utc().format("DD-MM-YYYY HH:mm");
    this.entryTable =
      moment(entry).utc().format("DD-MM-YYYY HH:mm") ===
      moment(exit).utc().format("DD-MM-YYYY HH:mm")
        ? ""
        : moment(entry).utc().format("DD-MM-YYYY HH:mm");
    this.exit =
      exit !== null
        ? licTot === "S"
          ? moment(exit).subtract(1, "days").utc().format("DD-MM-YYYY HH:mm")
          : moment(exit).utc().format("DD-MM-YYYY HH:mm")
        : "";
    this.conceptId = conceptId;
    this.nameConcept = nameConcept;
    this.ccId = ccId;
    this.nameCc = nameCc;
    this.inProcId = inProcId;
    this.inLine = inLine;
    this.outProcId = outProcId;
    this.outLine = outLine;
    this.obs = obs === null ? obs : "";
    this.licTot = licTot;
  }
  static fromJson({
    empId,
    nomEmpleado,
    legajo,
    entrada,
    salida,
    conceptoId,
    nomConcepto,
    csCostoId,
    nomCsCosto,
    entProcId,
    entLinea,
    salProcId,
    salLinea,
    observaciones,
    licTot,
  }) {
    return new attributs(
      empId,
      nomEmpleado,
      legajo,
      entrada,
      salida,
      conceptoId,
      nomConcepto,
      csCostoId,
      nomCsCosto,
      entProcId,
      entLinea,
      salProcId,
      salLinea,
      observaciones,
      licTot
    );
  }
}
export default attributs;
